<div class="modal-header">
	<button type="button" class="close" data-dismiss="modal">×</button>
	<h4 class="modal-title">{{title}}</h4>
</div>
<div class="modal-body">
	<svg id="svg-container" viewBox="0 0 400 300" width="100%" height="100%"
	xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
	xmlns="http://www.w3.org/2000/svg" version="1.1"
	xmlns:cc="http://creativecommons.org/ns#"
	xmlns:dc="http://purl.org/dc/elements/1.1/">

		<path id="svg-thermometer" d="M198,20 l0,200
		a26,26,
		0,
		1,
		0,
		24, 0
		l 0,-200"
		fill="red" stroke="black" stroke-width="4"/>

		{{!--  sun and moon label  --}}
		<svg id="svg-sun-group" viewBox="0 0 400 300" width="100%" height="100%">
			{{#COMPARE mode "!=" 1}}
				<g id="svg-sun" transform="translate(40,5) scale(.01)">
					{{{SVG-SUN}}}
				</g>
				<line id="svg-sun-line" x1="40" y1="27" x2="190" y2="27" stroke="grey" stroke-width="1"/>
			{{/COMPARE}}
		</svg>
		<svg id="svg-moon-group" viewBox="0 0 400 300" width="100%" height="100%">
			{{#COMPARE mode "!=" 2}}
				<g id="svg-moon" transform="translate(42,40) scale(.01) rotate(-50)">
					{{{SVG-MOON}}}
				</g>
				<line id="svg-moon-line" x1="40" y1="27" x2="190" y2="27" stroke="grey" stroke-width="1"/>
			{{/COMPARE}}
		</svg>


		{{!--  label showing the actual temperature  --}}
		<g id="svg-group-handle" class="clickable">
			<line x1="223" y1="18" x2="275" y2="18" stroke="grey"/>
            {{> BUTTON_RELEASED_TEXT buttonReleasedConfig}}
            {{> BUTTON_PRESSED_TEXT buttonPressedConfig}}
			{{!--  show a sun-/moon- or no Symbol, depending on the mode  --}}
			{{#COMPARE mode 1}}
				<g transform="translate(360,12) scale(.01)">
					{{{SVG-SUN "fill-day"}}}
				</g>
			{{/COMPARE}}
			{{#COMPARE mode 2}}
				<g transform="translate(360,23) scale(.015) rotate(-50)">
					{{{SVG-MOON "fill-night"}}}
				</g>
			{{/COMPARE}}
		</g>

		{{!--  rectangle with white filling, covering the red filling  --}}
		<rect id="svg-temperature" x="200" y="19" width="20" height="0" fill="white" stroke="none" stroke-width="0"/>
		{{!--  closing of the thermometer  --}}
		<path d="M198 22
		a10 8
		1 0 1
		24 0" stroke-width="4" stroke="black" fill="none"/>
	</svg>
	<div>
		<button id="js-minus" class="btn btn-temp-dec"> <i class="fa fa-minus"></i></button>
		<button id="js-plus" class="btn btn-temp-inc pull-right"><i class="fa fa-plus"></i></button>
	</div>
	{{#unless auto_timer_disabled}}
	{{#COMPARE mode "===" 0}}
	<div class='row'>
		<div class="col-sm-12">
			<div class="pull-right p-t-20">
				<span class="m-r-15">
					{{TR "Automatik-Modus wird wieder aktiv:"}}
					<strong id="js-validity-time">
					{{#if auto_timer_string}}
						{{auto_timer_string}}
					{{else}}
						{{TR "bei Regler Neustart"}}
					{{/if}}
					</strong>
				</span>
				<button id="js-edit-validity" class="btn btn-white pull-right">
					<i class="glyphicon glyphicon-pencil"></i>
				</button>
				{{#if auto_timer_string}}
				<button id="js-clear-validity" class="btn btn-white pull-right">
					<i class="glyphicon glyphicon-trash"></i>
				</button>
				{{/if}}
			</div>
		</div>
	</div>
	{{/COMPARE}}
	{{/unless}}
</div>
<div class="modal-footer">
	<button id="ct-cancel" type="button" class="btn btn-white" data-dismiss="modal">{{TR "Abbrechen"}}</button>
	<button type="button" class="btn btn-primary" id="js-save">{{TR "Speichern"}}</button>
</div>
